import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import {
  Observable,
  throwError
} from 'rxjs';
import {
  catchError
} from 'rxjs/operators';
import {
  Injectable
} from '@angular/core';
import { HandleErrorService } from '../core/services/handle-error.service';

@Injectable()
export class ServerErrorsInterceptor implements HttpInterceptor {

  constructor(
    private error: HandleErrorService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // TODO: Добавить обработку 206-го статуса ответа DumperError
    return next.handle(request)
      .pipe(catchError((error: HttpErrorResponse) => {
        return throwError(this.error.handleError(error));
      }));
  }
}
